import { sectionLabels } from "../section-labels";
/**
 * The loyalty strip — "KOYO CLUB — GOLD · 2,450 pts", "260 pts to a free
 * combo".
 *
 * ## previewOnly: there is no loyalty programme
 *
 * The platform has no points, no tiers, no member accounts and no diner
 * identity of any kind — a diner scanning a QR code is anonymous by design.
 * Every number in the artboards is a hardcoded string.
 *
 * So this section ships `visible: false` on every catalog entry and renders
 * only in the theme preview, badged. Shipping it live would print a stranger's
 * balance to whoever picked up the menu, or — more likely — print the same
 * fictional 2,450 to everyone, which is worse: it is a promise the restaurant
 * did not make and cannot keep.
 *
 * It exists at all so the theme preview shows the seller the shape of the
 * thing, and so the day a loyalty feature lands this is a renderer to wire up
 * rather than a design to rediscover.
 */
export const restaurantRewardsSchema = {
    type: "restaurant-rewards",
    name: sectionLabels["restaurant-rewards"],
    description: {
        ar: "شريط نقاط الولاء. لسه مش شغّال — بيظهر في المعاينة بس.",
        en: "The loyalty-points strip. Not built yet — preview only.",
    },
    previewOnly: true,
    maxPerTemplate: 1,
    availableOnTemplates: ["home"],
    availableOnStoreKinds: ["RESTAURANT"],
    settings: [
        {
            id: "headline",
            type: "text",
            i18n: true,
            label: { ar: "جملة البرنامج", en: "Programme line" },
            helpText: {
                ar: "الجملة اللي بتشرح البرنامج — مش رقم نقاط.",
                en: "The sentence that explains the programme — not a points figure.",
            },
            validate: { max: 80 },
        },
        {
            id: "programmeName",
            type: "text",
            i18n: true,
            label: { ar: "اسم البرنامج", en: "Programme name" },
            validate: { max: 40 },
        },
    ],
};
//# sourceMappingURL=restaurant-rewards.js.map